import React, { useContext, useEffect, memo } from 'react';
import { FixedSizeList as List, areEqual } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { styled } from '@nextiva/next-ui-components';

import {
  UserContext,
  actionTypes,
} from 'containers/pages/ManageUsers/usersContext';
import { sortUsers } from 'containers/pages/ManageUsers/helpers';
import { PermissionNeeded } from 'components';

import UserRow from './components/userRow';

const StyledDiv = styled('div')`
  margin-top: 25px;
`;

const UserList = ({ onEditUser }) => {
  const {
    userState: {
      userList = [],
      sortField,
      sortOrder,
      sortFieldType,
      userSearchString,
      baseUserList,
      userFilterStatus,
    },
    dispatch,
  } = useContext(UserContext);

  if (baseUserList.length === 0) {
    return (
      <StyledDiv>
        <PermissionNeeded />
      </StyledDiv>
    );
  }

  const Row = memo(({ index, style }) => {
    return (
      <UserRow
        key={index}
        user={userList[index]}
        onEditUser={onEditUser}
        style={style}
      />
    );
  }, areEqual);

  useEffect(() => {
    const sortedUsers = sortUsers(
      userList,
      sortField,
      sortFieldType,
      sortOrder,
    );

    dispatch({
      type: actionTypes.SET_USER_LIST,
      userList: sortedUsers,
    });
  }, [sortField, sortOrder, baseUserList, userFilterStatus, userSearchString]);

  return (
    <AutoSizer defaultWidth="100%">
      {({ height, width }) => {
        return (
          <List
            height={height}
            className="m-user-list"
            width={width}
            itemCount={userList.length}
            itemSize={71}
          >
            {Row}
          </List>
        );
      }}
    </AutoSizer>
  );
};

export default UserList;
